var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 14,
    y2: 0.5,
    stroke: "#3CB4E5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 5.5,
    x2: 14,
    y2: 5.5,
    stroke: "#3CB4E5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 10.5,
    x2: 14,
    y2: 10.5,
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleLine);
export default __webpack_public_path__ + "static/media/tripleLine.a0154d29b51f4febd8a598350a351a42.svg";
export { ForwardRef as ReactComponent };